import React from 'react';
import SubLayout from '../../components/Layout/SubLayout';
import strings from '../../components/Language';
import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';

import "./reward.scss";

import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from '../../components/config/api.js';
import { getToken, storeUserData } from '../../components/Util';
import _ from 'lodash';
import moment from 'moment';
import LoaderContext from '../../components/Loader/LoaderContext.js';

class ProfitMonthlyReportScreen extends React.Component {
	static contextType = LoaderContext;
	constructor(props) {
		super(props);
		this.state = {
			access_token: "",
			data: [],
			profit_data: [],
			profit_data_is_load: false,
			activation_reward: [],
			activation_reward_is_load: false,
			profit_reward: [],
			profit_reward_is_load: false,
		}
	}

	async componentDidMount() {
		var token = await getToken();
		if (token) {
			await storeUserData(token);
			this.setState({ access_token: token });
			setTimeout(() => {
				this.getData();
			});
		}
	}

	getData() {
		const { setLoading } = this.context;
		setLoading(true);
		var self = this;
		axios({
			method: 'GET',
			url: api.reward,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {
			if (ress.data && ress.data.error === 200) {
				self.setState({ data: ress.data.data });
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			setLoading(false);
		});
	};

	render() {

		return (
			<SubLayout data={{ "title": strings.reward_details }}>
				<div style={{ marginTop: 20 }}>
					<>
						<div className="list_item">
							<div className="row">
								<div className='col-4'>
									<div className=''>{moment().format("YYYY-MM-DD")}</div>
								</div>
								<div className='col-8'>
									<div className=''>
										<span className='gray_color'>{strings.profit}: </span>
										<span className='text_up'>{Number.parseFloat(1001).toFixed(5)}</span>
									</div>
									<div className='gray_color' style={{ fontSize: 12 }}>{strings.pair}: {'item.pair'}</div>
								</div>
							</div>
						</div>
					</>
				</div>
			</SubLayout>
		);
	}
}

export default ProfitMonthlyReportScreen;